import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import {
  ConfigurationGroupBasicModel,
  useListConfigurationGroupsQuery,
} from '@casops/store/apis/configurationGroupsApi';
import { useMemo } from 'react';

export const useConfigGroupOptions = (): DropdownItemProps<number>[] => {
  const { data: configGroups } = useListConfigurationGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  return useMemo<DropdownItemProps<number>[]>(() => {
    return configGroups
      ? configGroups.map(({ id, name }: ConfigurationGroupBasicModel) => {
          const stringValue = id.toString();
          return { key: stringValue, value: id, stringValue: stringValue, label: name };
        })
      : [];
  }, [configGroups]);
};
